import { useEffect, useState } from "react";

// SSR-safe default. `useState` initialisers run on BOTH the server and the
// client's first render. If we called `window.innerWidth` here, the server
// would see `undefined` (fallback to desktop) while the client would read the
// real viewport, causing a hydration mismatch (React #418) on any breakpoint
// where the two disagree — e.g. mobile chromium where actual width is ~360 but
// the server fell back to 1024. Keep this constant on first render; useEffect
// then syncs to the real viewport on the client.
const DEFAULT_DIMENSIONS = { width: 1024, height: 768 };

function getWindowDimensions() {
  if (typeof window !== "undefined") {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  return DEFAULT_DIMENSIONS;
}

export default function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(DEFAULT_DIMENSIONS);

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return windowDimensions;
}
